import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "outercontent"
};
const _hoisted_2 = {
  class: "innercontent"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  class: "offsetul"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "el-upload-list__item-actions"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  class: "bottombox"
};
const _hoisted_12 = {
  class: "bdmapcontainer"
};
const _hoisted_13 = {
  class: "mapsearchbox"
};
const _hoisted_14 = {
  id: "bdmap",
  class: "bdmap",
  ref: "bdmap"
};
const _hoisted_15 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_el_button = _resolveComponent("el-button");
  const _component_Delete = _resolveComponent("Delete");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_upload = _resolveComponent("el-upload");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_cascader = _resolveComponent("el-cascader");
  const _component_el_form = _resolveComponent("el-form");
  const _component_Search = _resolveComponent("Search");
  const _component_CircleCloseFilled = _resolveComponent("CircleCloseFilled");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_form, {
    model: $data.form,
    "label-width": "120px",
    ref: "form",
    "label-position": "top"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: $data.formlabel.place_name,
      prop: "place_name",
      rules: [{
        required: true,
        message: `请填写${$data.formlabel.place_name}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.place_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.place_name = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.showplace_name,
      prop: "showplace_name"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.showplace_name,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.showplace_name = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.showplace_name, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: "地点图片"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox",
        onClick: _cache[2] || (_cache[2] = $event => $options.uploadClick('4')),
        "file-list": $data.dfileList[4],
        "onUpdate:fileList": _cache[3] || (_cache[3] = $event => $data.dfileList[4] = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        limit: 1
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_3), _createElementVNode("span", _hoisted_4, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, '4')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_5)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[32] || (_cache[32] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: $data.formlabel.show4,
      prop: "show4"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.show4,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.form.show4 = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.show4, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.picwidth,
      prop: "picwidth"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input_number, {
        modelValue: $data.form.picwidth,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.form.picwidth = $event),
        min: 0
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.titleoffset,
      prop: "titleoffset"
    }, {
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_6, [_createElementVNode("li", null, [_cache[33] || (_cache[33] = _createElementVNode("label", null, "左边距", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.offsetX,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.form.offsetX = $event),
        min: 0
      }, null, 8, ["modelValue"])]), _createElementVNode("li", null, [_cache[34] || (_cache[34] = _createElementVNode("label", null, "上边距", -1)), _createVNode(_component_el_input_number, {
        modelValue: $data.form.offsetY,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.form.offsetY = $event),
        min: 0
      }, null, 8, ["modelValue"])])])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.map_type,
      prop: "map_type"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.map_type,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.form.map_type = $event),
        class: "m-2",
        placeholder: "请选择",
        rules: [{
          required: true,
          message: `请填写${$data.formlabel.map_type}`,
          trigger: 'blur'
        }]
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typeArr, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.value,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue", "rules"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.map_level,
      prop: "map_level",
      rules: [{
        required: true,
        message: `请选择${$data.formlabel.map_level}`,
        trigger: 'blur'
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form.map_level,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.form.map_level = $event),
        class: "m-2",
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.leveloptions, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.map_coordinates,
      prop: "map_coordinates",
      rules: [{
        required: true,
        message: `请选择${$data.formlabel.map_coordinates}`
      }]
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.map_coordinates,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.form.map_coordinates = $event)
      }, null, 8, ["modelValue"]), _cache[35] || (_cache[35] = _createElementVNode("div", {
        class: "description"
      }, "请在地图上点击，坐标自动回填到输入框", -1))]),
      _: 1
    }, 8, ["label", "rules"]), _ctx.fid === '216022' ? (_openBlock(), _createBlock(_component_el_form_item, {
      key: 0,
      label: $data.formlabel.pca,
      prop: "pca"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_cascader, {
        placeholder: "请选择",
        size: "large",
        options: $data.options,
        modelValue: $data.selectedOptions,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $data.selectedOptions = $event),
        onChange: $options.addressChange
      }, null, 8, ["options", "modelValue", "onChange"])]),
      _: 1
    }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
      label: $data.formlabel[42],
      prop: "42"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        modelValue: $data.form[42],
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.form[42] = $event),
        class: "m-2",
        placeholder: "请选择"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption[42], item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.title,
            label: item.title,
            value: item.title
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _withDirectives(_createVNode(_component_el_form_item, {
      label: $data.formlabel[44],
      prop: "44"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form[44],
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => $data.form[44] = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), [[_vShow, $data.form[42] === '链接']]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_form_item, {
      label: $data.formlabel.introduce,
      prop: "introduce",
      rules: $props.isAddDataflag && $data.form[42] === '弹窗' ? [{
        required: true,
        message: `请填写${$data.formlabel.introduce}`
      }] : []
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        rows: 4,
        type: "textarea",
        modelValue: $data.form.introduce,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => $data.form.introduce = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label", "rules"]), _createVNode(_component_el_form_item, {
      label: "轮播图片"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        class: "uploadbox upmore",
        onClick: _cache[15] || (_cache[15] = $event => $options.uploadClick('banner')),
        "file-list": $data.dfileList.banner,
        "onUpdate:fileList": _cache[16] || (_cache[16] = $event => $data.dfileList.banner = $event),
        "list-type": "picture-card",
        "auto-upload": false,
        action: "#",
        "on-change": $options.uploadChange,
        multiple: true,
        limit: 100
      }, {
        file: _withCtx(({
          file
        }) => [_createElementVNode("div", null, [_createElementVNode("img", {
          class: "el-upload-list__item-thumbnail",
          src: file.url,
          alt: ""
        }, null, 8, _hoisted_7), _createElementVNode("span", _hoisted_8, [_createElementVNode("span", {
          class: "el-upload-list__item-delete",
          onClick: $event => $options.handleRemove(file, 'banner')
        }, [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_Delete)]),
          _: 1
        })], 8, _hoisted_9)])])]),
        default: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[36] || (_cache[36] = [_createTextVNode("上传")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-change"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: $data.formlabel.audio,
      prop: "audio"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        onClick: _cache[17] || (_cache[17] = $event => $options.uploadClick('audio')),
        "file-list": $data.dfileList.audio,
        "onUpdate:fileList": _cache[18] || (_cache[18] = $event => $data.dfileList.audio = $event),
        ref: "upload",
        class: "uploadfilebox",
        action: "#",
        limit: 10,
        "auto-upload": false,
        "on-exceed": $options.handleExceed,
        "on-change": $options.uploadChange,
        "on-remove": $options.removeHandle
      }, {
        trigger: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [_createTextVNode("上传附件")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-exceed", "on-change", "on-remove"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.video,
      prop: "video"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_upload, {
        onClick: _cache[19] || (_cache[19] = $event => $options.uploadClick('video')),
        "file-list": $data.dfileList.video,
        "onUpdate:fileList": _cache[20] || (_cache[20] = $event => $data.dfileList.video = $event),
        ref: "upload",
        class: "uploadfilebox",
        action: "#",
        limit: 10,
        "auto-upload": false,
        "on-exceed": $options.handleExceed,
        "on-change": $options.uploadChange,
        "on-remove": $options.removeHandle
      }, {
        trigger: _withCtx(() => [_createVNode(_component_el_button, null, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [_createTextVNode("上传附件")])),
          _: 1
        })]),
        _: 1
      }, 8, ["file-list", "on-exceed", "on-change", "on-remove"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.telphone,
      prop: "telphone"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.telphone,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $data.form.telphone = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.route
    }, {
      default: _withCtx(() => [$props.isAddDataflag ? (_openBlock(), _createElementBlock("div", _hoisted_10, [$data.bdmap.address === undefined ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        onClick: $options.bdDialogHandle
      }, {
        default: _withCtx(() => _cache[39] || (_cache[39] = [_createTextVNode("选择位置")])),
        _: 1
      }, 8, ["onClick"])) : (_openBlock(), _createElementBlock("p", {
        key: 1,
        class: "desc",
        onClick: _cache[22] || (_cache[22] = (...args) => $options.bdDialogHandle && $options.bdDialogHandle(...args))
      }, _toDisplayString($data.bdmap.address), 1))])) : _createCommentVNode("", true), !$props.isAddDataflag ? (_openBlock(), _createElementBlock("a", {
        key: 1,
        class: "desc",
        onClick: _cache[23] || (_cache[23] = (...args) => $options.bdDialogHandle && $options.bdDialogHandle(...args))
      }, _toDisplayString($data.bdmap.address !== undefined ? $data.bdmap.address : '选择位置'), 1)) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.portal_link,
      prop: "portal_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.portal_link,
        "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $data.form.portal_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.special_link,
      prop: "special_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.special_link,
        "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => $data.form.special_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.virtual_link,
      prop: "virtual_link"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: $data.form.virtual_link,
        "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $data.form.virtual_link = $event)
      }, null, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel.linkTarget,
      prop: "linkTarget"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form.linkTarget,
        "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $data.form.linkTarget = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption.linkTarget, item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"]), _createVNode(_component_el_form_item, {
      label: $data.formlabel[34],
      prop: "34"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        modelValue: $data.form[34],
        "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $data.form[34] = $event),
        class: "ml-4"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.formoption[34], item => {
          return _openBlock(), _createBlock(_component_el_radio, {
            label: item.title
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
            _: 2
          }, 1032, ["label"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }, 8, ["label"])], 512), [[_vShow, $data.form[42] === '弹窗']])]),
    _: 1
  }, 8, ["model"])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
    onClick: $options.gobacktype
  }, {
    default: _withCtx(() => _cache[40] || (_cache[40] = [_createTextVNode("返回")])),
    _: 1
  }, 8, ["onClick"]), _withDirectives(_createVNode(_component_el_button, {
    onClick: $options.deletedataHandle
  }, {
    default: _withCtx(() => _cache[41] || (_cache[41] = [_createTextVNode("删除")])),
    _: 1
  }, 8, ["onClick"]), [[_vShow, !$props.isAddDataflag]]), _createVNode(_component_el_button, {
    type: "primary",
    onClick: $options.submitdataHandle
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($props.isAddDataflag ? '提交' : '更新'), 1)]),
    _: 1
  }, 8, ["onClick"])]), _createVNode(_component_el_dialog, {
    modelValue: $data.bdDialog,
    "onUpdate:modelValue": _cache[31] || (_cache[31] = $event => $data.bdDialog = $event),
    title: "选择位置"
  }, {
    footer: _withCtx(() => [_createElementVNode("span", _hoisted_15, [_createVNode(_component_el_button, {
      onClick: _cache[29] || (_cache[29] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => _cache[44] || (_cache[44] = [_createTextVNode("取消")])),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: _cache[30] || (_cache[30] = $event => $data.bdDialog = false)
    }, {
      default: _withCtx(() => _cache[45] || (_cache[45] = [_createTextVNode("确定")])),
      _: 1
    })])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_el_icon, {
      class: "search"
    }, {
      default: _withCtx(() => [_createVNode(_component_Search)]),
      _: 1
    }), _cache[42] || (_cache[42] = _createElementVNode("input", {
      class: "inputel",
      id: "suggestId",
      placeholder: "输入地址搜索或指直接在下面选择定位"
    }, null, -1)), _cache[43] || (_cache[43] = _createElementVNode("div", {
      id: "searchResultPanel",
      style: {
        "border": "1px solid #C0C0C0",
        "width": "150px",
        "height": "auto",
        "display": "none"
      }
    }, null, -1)), _createVNode(_component_el_icon, {
      class: "iconclose"
    }, {
      default: _withCtx(() => [_createVNode(_component_CircleCloseFilled)]),
      _: 1
    })]), _createElementVNode("div", _hoisted_14, null, 512), _createElementVNode("h4", null, _toDisplayString($data.bdmap.address), 1)])]),
    _: 1
  }, 8, ["modelValue"])]);
}